/**
 * Common regex patterns for validating text inputs.
 */
export const INPUT_VALIDATORS = {
    CREATE_CARD_NUMBER: '^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|6(?:011|5[0-9]{2})[0-9]{12})$',
    CREDIT_CARD_SECURITY_NUMBER: '^[\\d]{3}(\\d{1})?$',
    /**
     * Format `dd/mm/yyyy`.
     * NOTE: Does not account for leap year. Only checks format.
     */
    DATE: '^(0[1-9]|1[0-2])[-/](0[1-9]|1\\d|2\\d|3[0-1])[-/](1900|19\\d{2}|20\\d{2})$',
    /**
     * name@domain.com
     */
    EMAIL: '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    /**
     * Chars - `A-Z`, `a-z`, ` `, and `-`. Must begin & end with a letter.
     */
    NAME: '^([a-zA-Z])$|^([a-zA-Z -]+[a-zA-Z]+)$',
    NO_NUMBER_AND_SPECIAL_CHARACTERS: '^[a-zA-Zs]+$',
    ONLY_LETTERS_AND_SPACES: '^[a-zA-Zs ]+$',
    LETTERS: '^[a-zA-Z]+$',
    PASSWORD: '^.{6,}$',
    PHONE_NUMBER: '^(1)[\\(]{0,1}[2-9][0-9]{2}[\\)]{0,1}[ ]?([^0-1]){1}([0-9]){2}[ ]?[-]?[ ]?([0-9]){4}[ ]*((x){0,1}([0-9]){1,5}){0,1}$',
    /**
     * 5 number length.
     * NOTE: do we want to support long?
     */
    POSTAL_CODE: '(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)',
    /**
     * Format - `123456789`.
     * The valid SSN (Social Security Number) must satisfy the following conditions:
     * The first part should have 3 digits and should not be 000, 666, or between 900 and 999.
     * The second part should have 2 digits and it should be from 01 to 99.
     * The third part should have 4 digits and it should be from 0001 to 9999.
     */
    SSN: '^(?!666|000|9\\d{2})\\d{3}(?!00)\\d{2}(?!0{4})\\d{4}$',
    /**
     * Makes a validator mark the field as not required as the validation makes the filed
     * required if included.
     */
    NOT_REQUIRED: (validator) => `(${validator}|^$)`,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdG9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvdmFsaWRhdG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHO0lBQzlCLGtCQUFrQixFQUNoQiw0SkFBNEo7SUFDOUosMkJBQTJCLEVBQUUscUJBQXFCO0lBQ2xEOzs7T0FHRztJQUNILElBQUksRUFBRSw0RUFBNEU7SUFDbEY7O09BRUc7SUFDSCxLQUFLLEVBQ0gsdUtBQXVLO0lBQ3pLOztPQUVHO0lBQ0gsSUFBSSxFQUFFLHVDQUF1QztJQUM3QyxnQ0FBZ0MsRUFBRSxjQUFjO0lBQ2hELHVCQUF1QixFQUFFLGVBQWU7SUFDeEMsT0FBTyxFQUFFLGFBQWE7SUFDdEIsUUFBUSxFQUFFLFNBQVM7SUFDbkIsWUFBWSxFQUNWLHNIQUFzSDtJQUN4SDs7O09BR0c7SUFDSCxXQUFXLEVBQUUsb0NBQW9DO0lBQ2pEOzs7Ozs7T0FNRztJQUNILEdBQUcsRUFBRSx1REFBdUQ7SUFFNUQ7OztPQUdHO0lBQ0gsWUFBWSxFQUFFLENBQUMsU0FBaUIsRUFBRSxFQUFFLENBQUMsSUFBSSxTQUFTLE1BQU07Q0FDaEQsQ0FBQyJ9